<template>
    <component :is="level" >
      <BlockEditor v-if="switchToEditor" :contentId = "blockId" :styleObject = "getStyle(data?.style)" :data="data"/>
      <div v-else @click = "clicked = true" v-html="parsedText" :style="getStyle(data?.style)"></div>
    </component>
  </template>
  
  <script>
  import { mapState } from 'vuex';
  import DOMPurify from 'dompurify';
  import BlockEditor from './EditorHelper/BlockEditor.vue';
  import { replacePlaceholders } from '@/utils/replacePlaceholders';
  
  export default {
    name: 'HeadingBlock',
    components: {BlockEditor},
    props: {
      data: Object,
      blockId: String
    },
    data() {return {
    clicked: false
  }},
    computed: {
      ...mapState(['placeholdersEnabled', 'customerData', 'sharedData']),
      switchToEditor() {
        return this.sharedData && this.sharedData.id == this.blockId; 
      },
      level() {
        return this.data?.props?.level || 'h2';
      },  
      parsedText() {
        let text = DOMPurify.sanitize(this.data?.props?.text, {ADD_ATTR: ['target', 'rel']}) || ''; // cleans content for safety reasons
        let size;
        switch(this.data?.props?.level){
          case 'h1':
            size = 27;
            break;
          case 'h2':
            size = 19;
            break;
          case 'h3':
            size = 14;
            break;
          default:
            size = 19;
            break;

        }
        if (this.placeholdersEnabled) {
          text = replacePlaceholders(text, true)
        }else{
        text = text.replace(/\[\[(.*?)\]\]/g,  function(match, p1){
              // Formatierung: Kursiv und grün
              return `<span style="color: #05bbef"><span class="material-symbols-outlined" style="font-size : ${size}px"> bolt</span>${p1} <span class="material-symbols-outlined" style="font-size :  ${size}px"> bolt</span></span> `;})
      }
        return text;
    },
    },
    methods: {
      getStyle(style) {
        const fontFamilyMapping = {
          BOOK_SANS: 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif',
          ORGANIC_SANS: 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif',
          GEOMETRIC_SANS: 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif',
          HEAVY_SANS: 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif',
          ROUNDED_SANS: 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif',
          MODERN_SERIF: 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif',
          BOOK_SERIF: '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif',
          MONOSPACE: '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace',
          MODERN_SANS: '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif',
          SIMPLE: 'Arial',
          DEFAULT: 'inherit'
        };
        const fontFamily = fontFamilyMapping[style?.fontFamily] || fontFamilyMapping.DEFAULT;
        const defaultTextAlign = 'left';
        const defaultFontWeight = 'bold';
        const padding = style?.padding || { top: 0, bottom: 0, left: 0, right: 0 };
        return {
          color: style?.color || null,
          backgroundColor: style?.backgroundColor || null,
          fontWeight: style.fontWeight || defaultFontWeight,
          textAlign: style.textAlign || defaultTextAlign,
          padding: `${padding.top}px ${padding.right}px ${padding.bottom}px ${padding.left}px`,
          fontFamily: fontFamily,
        };
      },
    },
  };
  </script>
  
  
  
  